import { DestroyRef, inject, LOCALE_ID } from '@angular/core';
import { ConfigLoaderService } from '@core/services/config-loader.service';
import { DataService } from '@core/services/data.service';
import { IframeTools } from '@core/services/iframe-tools.service';
import { MediaObserverService } from '@core/services/media-observer.service';
import { MetaService } from '@core/services/meta.service';
import { TaggingService } from '@core/services/tagging.service';
import {
  CampaignPhase,
  CampaignTypes,
  DeviceType,
  DISPLAY_CONDITION,
  Pages,
  RETAILERS,
  StepStatus,
  TitleType,
  Variants,
} from '@shared/constants';
import {
  CouponsConfig,
  LoyaltyChallengeConfig,
  ProjectTypes,
} from '@shared/models';

export abstract class BaseComponent {
  // PROVIDERS
  protected readonly destroyRef = inject(DestroyRef);
  protected readonly metaService = inject(MetaService);
  protected readonly iframeTools = inject(IframeTools);
  protected readonly dataService = inject(DataService);
  protected readonly locale: string = inject(LOCALE_ID);
  protected readonly configLoaderService = inject(ConfigLoaderService);
  protected readonly mediaObserverService = inject(MediaObserverService);
  protected readonly taggingService: TaggingService = inject(TaggingService);

  // CONSTANTS
  public readonly PAGES: typeof Pages = Pages;
  public readonly Variants: typeof Variants = Variants;
  public readonly TitleType: typeof TitleType = TitleType;
  public readonly Retailers: typeof RETAILERS = RETAILERS;
  public readonly DeviceType: typeof DeviceType = DeviceType;
  public readonly StepStatus: typeof StepStatus = StepStatus;
  public readonly ProjectTypes: typeof ProjectTypes = ProjectTypes;
  public readonly CampaignTypes: typeof CampaignTypes = CampaignTypes;
  public readonly CampaignPhase: typeof CampaignPhase = CampaignPhase;
  public readonly DISPLAY_CONDITION: typeof DISPLAY_CONDITION =
    DISPLAY_CONDITION;

  // VARIABLES
  protected device = this.mediaObserverService.device;
  protected mqAlias = this.mediaObserverService.mqAlias;

  protected environment = this.dataService.environment();
  protected couponsConfig = this.dataService.config() as CouponsConfig;
  protected loyaltyChallengeConfig =
    this.dataService.config() as LoyaltyChallengeConfig;
}
